import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import {DiffComparisonViewer} from '../components/DiffComparisonViewer'
import {Suspense, useEffect} from 'react'
import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {usePullRequestAnalytics} from '../hooks/use-pull-request-analytics'

// entrypoint for JSON route - not DataRouter
export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  const routeData = useRoutePayload<FilesRoutePayload>()

  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  useEffect(() => {
    sendPullRequestAnalyticsEvent('page_view.files_page', 'PAGE_VIEW', {
      browser_width: typeof window !== 'undefined' ? window.innerWidth : 0,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AnalyticsProvider
      appName="pull-request-files"
      category="files_tab"
      metadata={{
        pull_request_id: routeData.pullRequest.id,
        base_sha: routeData.pullRequest.comparison.baseOid,
        head_sha: routeData.pullRequest.comparison.headOid,
      }}
    >
      <Suspense>
        <DiffComparisonViewer.Viewer
          basePath={routeData.pullRequest.pathName}
          initialData={routeData}
          useAdvancedToolbar
          useChangeGroups
          useInlineComments
          useEditOptions
          useFileTree
        />
      </Suspense>
    </AnalyticsProvider>
  )
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}